import { LocalizedTranslations } from '../localizedTranslations';

export const ar: LocalizedTranslations = {
  // Navigation
  nav: {
    home: 'الرئيسية',
    europeanMarkets: 'الأسواق الأوروبية',
    aboutUs: 'من نحن',
    products: 'المنتجات',
    oemSolutions: 'حلول OEM',
    blog: 'المدونة',
    clientHub: 'بوابة العملاء',
    agentLogin: 'دخول الوكلاء',
    contact: 'اتصل بنا',
    getStarted: 'ابدأ الآن',
    smartToilets: 'المراحيض الذكية',
    businessSolutions: 'حلول الأعمال',
    technology: 'التكنولوجيا',
    about: 'حول',
    viewAllProducts: 'عرض جميع المنتجات',
    flagship: 'الرائد',
    productDescriptions: {
      rem7: 'مرحاضنا الذكي الأول',
      luxa: 'خط الفخامة المطلقة',
      luna: 'مدمج بسيط',
      nova: 'مرحاض ذكي عائلي',
      aria: 'تصميم فاخر بيئي',
      vena: 'بيديه فاخر',
      aurelius: 'أناقة كلاسيكية',
      aurelux: 'إصدار بلمسات ذهبية',
      luma: 'ابتكار ذكي',
    },
  },
  
  // Common
  common: {
    learnMore: 'اعرف المزيد',
    viewDetails: 'عرض التفاصيل',
    requestQuote: 'طلب عرض سعر',
    downloadCatalog: 'تحميل الكتالوج',
    contactUs: 'تواصل معنا',
    readMore: 'اقرأ المزيد',
    seeAll: 'عرض الكل',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    send: 'إرسال',
    close: 'إغلاق',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
  },
  
  // Homepage
  home: {
    heroTitle: 'مراحيض ذكية فاخرة للأسواق الأوروبية',
    heroSubtitle: 'اختبر مستقبل الفخامة في الحمام مع التصميم الذكي والتكنولوجيا المتطورة',
    exploreCollection: 'استكشف المجموعة',
    watchVideo: 'شاهد الفيديو',
    featuredProducts: 'المنتجات المميزة',
    whyChooseUs: 'لماذا تختار Aureum VII Trading',
    testimonials: 'ماذا يقول عملاؤنا',
    certifications: 'الشهادات والمعايير',
  },
  
  // Products
  products: {
    title: 'مجموعتنا من المراحيض الذكية',
    subtitle: 'اكتشف مجموعتنا من حلول الحمام الذكية الفاخرة',
    features: 'المميزات',
    specifications: 'المواصفات الفنية',
    installation: 'دليل التركيب',
    warranty: 'معلومات الضمان',
    dimensions: 'الأبعاد',
    waterUsage: 'استهلاك المياه',
    powerConsumption: 'استهلاك الطاقة',
    weight: 'الوزن',
    material: 'المادة',
    certification: 'الشهادة',
    relatedProducts: 'منتجات ذات صلة',
  },
  
  // Contact
  contact: {
    title: 'تواصل معنا',
    subtitle: 'يسعدنا سماعك. أرسل لنا رسالة وسنرد عليك في أقرب وقت ممكن.',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    company: 'اسم الشركة',
    message: 'رسالتك',
    sendMessage: 'إرسال الرسالة',
    ourLocation: 'موقعنا',
    emailUs: 'راسلنا',
    callUs: 'اتصل بنا',
    businessHours: 'ساعات العمل',
    weekdays: 'الاثنين - الجمعة: 9:00 صباحاً - 6:00 مساءً',
    weekend: 'السبت - الأحد: مغلق',
  },
  
  // About
  about: {
    title: 'عن Aureum VII Trading',
    subtitle: 'شريكك الموثوق لحلول المراحيض الذكية الفاخرة في أوروبا',
    ourStory: 'قصتنا',
    ourMission: 'مهمتنا',
    ourVision: 'رؤيتنا',
    ourValues: 'قيمنا',
    quality: 'الجودة',
    innovation: 'الابتكار',
    sustainability: 'الاستدامة',
    customerFocus: 'التركيز على العملاء',
  },
  
  // Footer
  footer: {
    description: 'حلول مراحيض ذكية فاخرة للسوق الأوروبي. اختبر الفخامة والابتكار والاستدامة.',
    quickLinks: 'روابط سريعة',
    products: 'المنتجات',
    support: 'الدعم',
    legal: 'قانوني',
    privacyPolicy: 'سياسة الخصوصية',
    termsConditions: 'الشروط والأحكام',
    returnPolicy: 'سياسة الإرجاع',
    shippingPolicy: 'سياسة الشحن',
    allRightsReserved: 'جميع الحقوق محفوظة.',
    followUs: 'تابعنا',
  },
  
  // Forms
  forms: {
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
    invalidPhone: 'يرجى إدخال رقم هاتف صحيح',
    messageSent: 'تم إرسال رسالتك بنجاح!',
    errorSending: 'حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى.',
  },
  
  // FAQ
  faq: {
    title: 'الأسئلة الشائعة',
    subtitle: 'اعثر على إجابات للأسئلة الشائعة حول مراحيضنا الذكية',
    stillHaveQuestions: 'هل لديك أسئلة أخرى؟',
    contactSupport: 'تواصل مع فريق الدعم',
  },
  
  // Blog
  blog: {
    title: 'أحدث المقالات',
    subtitle: 'ابق على اطلاع بأحدث اتجاهات تكنولوجيا الحمام الذكي',
    readingTime: 'دقيقة قراءة',
    author: 'بواسطة',
    publishedOn: 'نُشر في',
    categories: 'الفئات',
    tags: 'الوسوم',
    relatedArticles: 'مقالات ذات صلة',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'مراحيض ذكية فاخرة | Aureum VII Trading',
    homeDescription: 'مورّد B2B للمراحيض الذكية الفاخرة وأحواض الاستحمام والجاكوزي ووحدات الأحواض للمطورين والفنادق والمعماريين في أوروبا. حاصل على شهادة CE.',
    productsTitle: 'مجموعة المراحيض الذكية | Aureum VII',
    productsDescription: 'تصفح مجموعة REM7 كاملة: تسخين فوري بدون خزان، مقاعد بيديه مدفأة، وتعقيم بالأشعة فوق البنفسجية. معتمدة CE ومتاحة بكميات المشاريع.',
    contactTitle: 'اتصل بنا وطلبات الجملة | Aureum VII',
    contactDescription: 'تواصل مع Aureum VII Trading في ماربيا لتوريد المراحيض الذكية وتجهيزات الحمامات: أسعار الجملة، الحد الأدنى للطلب، التصنيع الخاص، والشحن داخل أوروبا.',
    aboutTitle: 'عن Aureum VII Trading | مورّد أوروبي',
    aboutDescription: 'تورّد Aureum VII Trading من ماربيا بإسبانيا المراحيض الذكية وتجهيزات الحمامات الفاخرة للمطورين والفنادق والمعماريين في جميع أنحاء أوروبا.',
    defaultTitle: 'Aureum VII Trading | مراحيض ذكية فاخرة',
    defaultDescription: 'مراحيض ذكية وتجهيزات حمامات فاخرة بمقاعد مدفأة ووظائف بيديه وتحكم ذكي، تورّدها Aureum VII Trading في جميع أنحاء أوروبا.',
    rem7Title: 'REM7 — المرحاض الذكي الرائد | Aureum VII',
    rem7Description: 'REM7 هو المرحاض الذكي الرائد من Aureum VII Trading: بيديه مدمج، تسخين فوري، تعقيم UV، ووضع اقتصادي. عرض خاص: 600 يورو للوحدة.',
    luxaTitle: 'LUXA — مرحاض ذكي فاخر | Aureum VII',
    luxaDescription: 'يجمع LUXA بين التصميم الأوروبي والتقنية المتقدمة: بيديه بدرجة حرارة قابلة للضبط، إضاءة ليلية LED، وتعقيم UV. عرض خاص: 600 يورو للوحدة.',
    bathSanitaryTitle: 'أحواض ومستلزمات حمام فاخرة | Aureum VII',
    bathSanitaryDescription: 'كتالوج B2B لأحواض الاستحمام والجاكوزي والمغاسل ووحدات الحمام الفاخرة. أسعار بالجملة للفنادق والمطورين والمعماريين في أوروبا.',
    businessTitle: 'حلول B2B للفنادق والمطورين | Aureum VII',
    businessDescription: 'أسعار بالكميات ودعم التصنيع الخاص وخدمات الشحن في أوروبا للمعماريين والفنادق ومطوري العقارات. اطلب عرض سعر تجاري.',
    compareTitle: 'قارن المراحيض الذكية | Aureum VII',
    compareDescription: 'قارن المزايا والأسعار والمواصفات لجميع طرازات REM7 جنبًا إلى جنب للعثور على المرحاض الذكي المناسب لمشروعك.',
    faqTitle: 'الأسئلة الشائعة | Aureum VII Trading',
    faqDescription: 'إجابات حول التركيب والضمان والصيانة وأسعار مراحيض REM7 الذكية. كل ما تحتاج معرفته قبل الطلب.',
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 مرحاض ذكي فاخر | تقنية السبا الصحية',
      description: 'اكتشف مرحاض LUNA M9 الذكي مع التسخين الفوري والشاشة الرقمية والتنظيف العلاجي وميزات العافية.',
      heroTitle: 'LUNA',
      heroSubtitle: 'الموديل M9',
      heroDescription: 'مرحاض LUNA M9 الذكي الفاخر يجمع بين الأناقة الخالدة والوظائف المتقدمة المركزة على العافية.',
      features: {
        heatedSeat: 'مقعد ساخن مع إضاءة ليلية',
        washModes: 'أوضاع غسيل متعددة',
        dryingFunction: 'وظيفة تجفيف ذكية',
        modernDesign: 'تصميم عصري أنيق',
      },
      cta: {
        downloadSpec: 'تحميل المواصفات',
        backToCollections: '← العودة إلى المجموعات',
        requestQuote: 'طلب عرض أسعار',
      },
    },
    luxa: {
      title: 'LUXA M80 مرحاض ذكي رائد | نظام بيديه فاخر',
      description: 'مرحاض LUXA M80 الذكي الرائد مع مستشعرات الحركة والتسخين بدون خزان والتعقيم بالأشعة فوق البنفسجية والأتمتة الفاخرة.',
      heroTitle: 'LUXA',
      heroSubtitle: 'الموديل: M80',
      heroDescription: 'LUXA M80 هو الرائد في مجموعتنا الفاخرة، يمثل قمة الابتكار في الحمامات الذكية.',
      features: {
        motionSensor: 'غطاء بمستشعر الحركة',
        tanklessHeating: 'تسخين فوري بدون خزان',
        adjustableTemp: 'درجة حرارة وضغط الماء قابلة للتعديل',
        premiumCeramic: 'سيراميك فاخر + غطاء ناعم الإغلاق',
        ecoDesign: 'تصميم صديق للبيئة',
      },
      cta: {
        downloadSpec: 'تحميل المواصفات',
        backToCollections: '← العودة إلى المجموعات',
        requestQuote: 'طلب عرض أسعار',
      },
    },
    aria: {
      title: 'ARIA H60 مرحاض ذكي معلق | تصميم موفر للمساحة',
      description: 'مرحاض ARIA H60 الذكي المعلق بتصميم معماري أنيق وتقنية بيديه متقدمة وتركيب موفر للمساحة.',
      heroTitle: 'ARIA',
      heroSubtitle: 'الموديل H60',
      heroDescription: 'يركز ARIA H60 على التصميم المعماري البسيط مع أقصى راحة ووظائف ذكية.',
      features: {
        bidetSpray: 'رذاذ بيديه قابل للتعديل',
        waterSaving: 'تقنية توفير المياه',
        compactFit: 'مناسب للحمامات الصغيرة',
        softClose: 'غطاء ناعم الإغلاق',
      },
      cta: {
        downloadSpec: 'تحميل المواصفات',
        backToCollections: '← العودة إلى المجموعات',
        requestQuote: 'طلب عرض أسعار',
      },
    },
  },
};
